import { dataTestRoot } from "@/constants";
/**
 * @deprecated This will be removed. I just want to avoid breaking Cypress tests now
 */
export const useContactingTestId = (key) => `${dataTestRoot}.Contacting.${key}`;
